import lodash from 'lodash'
import React, { useState } from 'react'

import Alert from '../../../../1stlog-ui/src/components/Alert'
import { Col, Row } from '../../../../1stlog-ui/src/components/Bootstrap'
import { BoxStyle, Header } from '../../../../1stlog-ui/src/components/Box'
import Button from '../../../../1stlog-ui/src/components/Button'
import Icon from '../../../../1stlog-ui/src/components/Icon'
import PrintFormatSelect from '../../../../shipmetrics-shared/components/PrintFormatSelect'
import BlockedPopupAlert from '../../../components/BlockedPopupAlert'

type TProps = {
  order: object
  labelToken: string
  onClose: () => void
}

const Success = (props: TProps): React.ReactElement => {
  const { order, labelToken, onClose = lodash.noop } = props

  console.log('Success order', order)

  // TODO: check actual values
  const isPrintRequested = lodash.get(order, 'isPrintRequested')

  // TODO: check actual values
  const isProformaLight =
    lodash.get(order, 'shipmentServices.PFL.proformaLight') ||
    lodash.get(order, 'proformaInvoice')

  const [wasPopupBlocked, setWasPopupBlocked] = useState(false)

  const onPopupBlocked = (): void => setWasPopupBlocked(true)

  const resetWasPopupBlocked = (): void => setWasPopupBlocked(false)

  return (
    <div>
      <div>
        <Alert success title={`${i18n.t('success', 'Erfolg')}!`}>
          {i18n.t(
            'order_was_succesfully_registered_in_the_system',
            'Der Auftrag wurde erfolgreich im System registriert.',
          )}
        </Alert>
      </div>

      <BoxStyle className="mt-2">
        <Header className="mx-n2">
          {i18n.t('parcel_label', 'Paketlabel')}
        </Header>
        <div>
          <div>
            {isPrintRequested ? (
              <p>
                {i18n.t(
                  'the_order_has_been_sent_to_your_selectet_printer_if_it_does_not_print_please_check_if_printingtool_is_running_and_printer_is_working_correctly_alternatively_you_can_obtain_the_label_directly_by_clicking_on_the_button_below',
                  'Der Auftrag wurde an Ihren ausgewählten Drucker gesendet. Sollte dieser nicht drucken, prüfen Sie bitte ob das "Printingtool" läuft und der Drucker korrekt arbeitet. Alternativ können Sie das Label durch Klick auf den untenstehenden Button direkt beziehen.',
                )}
              </p>
            ) : (
              <p>
                {i18n.t(
                  'if_the_window_with_the_label_did_not_open_please_check_your_pop-up-blocker_and_open_the_label_again_by_clicking_on_the_button_below',
                  'Sollte sich das Fenster mit dem Label nicht geöffnet haben, prüfen Sie bitte Ihren Popupblocker und öffnen Sie das Label durch Klick auf den untenstehenden Button erneut.',
                )}
              </p>
            )}
          </div>
          <PrintFormatSelect
            labelToken={labelToken}
            openOnMount={!isPrintRequested}
            back={lodash.noop}
            text={i18n.t('print_label_again', 'Label erneut drucken')}
            onPopupBlocked={onPopupBlocked}
          />
        </div>
      </BoxStyle>
      {wasPopupBlocked && (
        <Row className="mt-2">
          <Col>
            <BlockedPopupAlert onClose={resetWasPopupBlocked} />
          </Col>
        </Row>
      )}
      {isProformaLight && (
        <BoxStyle className="mt-3">
          <Header className="mx-n2">
            {i18n.t('proforma_invoice', 'Proforma-Rechnung')}
          </Header>
          <div>
            <p>
              {i18n.t(
                'download_proforma_receipt_through_clicking_on_the_button_below',
                'Laden Sie die Proforma-Rechnung durch Klick auf den Button herunter.',
              )}
            </p>
          </div>
          <div>
            <Button
              info
              icon="far fa-download"
              href={`/auftrag/api/order/proforma/${labelToken}`}
              target="_blank"
            >
              {i18n.t(
                'download_proforma_receipt',
                'Proforma-Rechnung herunterladen',
              )}
            </Button>
          </div>
        </BoxStyle>
      )}
      <div className="mt-2 d-flex justify-content-end">
        <div className="mr-2">
          <Button icon="fas fa-external-link" href="/orders">
            {i18n.t('view_orders', 'Aufträge ansehen')}
          </Button>
          {/* <Button onClick={onClose} variant="default">
            <Icon icon="fas fa-external-link-alt" className="mr-1" /> Weiteren
            Auftrag erfassen
          </Button> */}
        </div>
        <div>
          <Button onClick={onClose} info>
            <Icon icon="fas fa-file" className="mr-1" />
            {i18n.t('enter_another_oreder', 'Weiteren Auftrag erfassen')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Success
